import { Tooltip } from "@material-ui/core";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import $ from "jquery";

export const TemplateBoxtag = ({ ...props }) => {
  const [checked, setChecked] = React.useState({});
  let wrapperStyle = getBoxTagWrapperStyle(props.display[0]);
  let itemStyle = getBoxtagStyleItem(
    props.display[0].indexOf("boxtag") > -1 ? "boxtag" : "tagging",
    props.display[0]
  );
  if(props.display[0].indexOf("choices-noshow") >= 0 ){
    return (
        <>choice no show</>
    )
  }
  return (
    <div style={wrapperStyle}>
      {
        props.display[0].indexOf("-search")>-1 &&
        <div className="input-group">
            <input
            type="text"
            className="tf-text-input kt-align-left tf-search-boxtag"
            autoComplete="off"
            style={{ paddingRight: 80 }}
            />
            {/* <div  style={{ display: "none" }}>
                <button
                    type="button"
                    className="btn"
                    style={{
                    position: "absolute",
                    right: 30,
                    zIndex: 5,
                    padding: "5px 15px",
                    }}
                >
                    <i
                    className="la la-times"
                    style={{
                        paddingRight: 0,
                        color: "var(--answer-color)",
                        fontSize: "var(--font-size-answer-select)",
                        marginBottom: 3,
                        fontWeight: 900,
                    }}
                    />
                </button>
            </div> */}
        </div>
      }
      <div className="boxtag-scroll">
        {props.choicesListNew[props.choice]?.map((choice, index) => {
          return (
            <Tooltip
              key={`${props.choice}_${choice.name}_key`}
              title={
                !props.previewForm && 
                (props.previewForm || props.collector.Choice === "TRUE") &&
                window.ListNameDefault.indexOf(props.choice) === -1
                  ? "Double click to edit"
                  : ""
              }
              placement="bottom"
            >
              <div
                className="d-inline position-relative"
                onClick={(e) => {
                  if (checked?.[choice.name]) {
                    setChecked({ [choice.name]: false });
                  } else {
                    setChecked({ [choice.name]: true });
                  }
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDoubleClick={(e) => {
                  (props.previewForm ||
                    props.collector.XlsType !== "SINGLE_TEMPLATE") &&
                    window.ListNameDefault.indexOf(props.choice) === -1 &&
                    props.handleClickOpen(choice);

                  e.preventDefault();
                  e.stopPropagation();
                }}
                onMouseOver={() => {
                  $(`#${props.choice}_${choice.name}_dlt_btn`).css(
                    "opacity",
                    "1"
                  );
                }}
                onMouseOut={() => {
                  $(`#${props.choice}_${choice.name}_dlt_btn`).css(
                    "opacity",
                    "0"
                  );
                }}
              >
                <label
                  className="tf-boxtag-select btn"
                  style={
                    checked?.[choice.name]
                      ? itemStyle.checked
                      : itemStyle.unchecked
                  }
                >
                  <font
                    className="kt-valign-middle"
                    style={{ display: "table-cell" }}
                  >
                    {choice["label::" + props.language]}
                  </font>
                </label>
                {(props.previewForm || props.collector.Choice === "TRUE") &&
                  window.ListNameDefault.indexOf(props.choice) === -1 && (
                    <lable
                      id={`${props.choice}_${choice.name}_dlt_btn`}
                      className="m-0 dlt_choice_btn"
                      onClick={(e) => {
                        props.handleDeleteChoice(choice, props.choicesList);
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </lable>
                  )}
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
};

function getBoxTagWrapperStyle(appearances) {
  let wrapperStyle = {
    padding: "0.65rem 1rem",
    borderRadius: "4px",
    flexGrow: "1",
    background: "#ffffff00",
  };
  let colorCode = appearances.match(/[0-9a-f]{6}/gi);
  if (colorCode !== null) {
    wrapperStyle.border = "1px solid #" + colorCode[0];
  } else {
    wrapperStyle.border = "1px solid var(--answer-color)";
  }

  return wrapperStyle;
}

function getBoxtagStyleItem(display, appearances) {
  const itemStyle = {
    padding: "0.25rem .5rem",
    marginRight: "10px",
    marginTop: "0.5rem",
    marginBottom: "0.5rem",
    cursor: "pointer",
  };

  if (display === "tagging") {
    itemStyle.borderRadius = "20px";
  }

  let colorCode = appearances.match(/[0-9a-f]{6}/gi);
  let isFill = appearances.indexOf("-fill") >= 0;

  let unchecked = {};
  let checked = {};

  if (colorCode === null) {
    unchecked["color"] = "var(--answer-color)";
    checked["color"] = "var(--answer-color)";
    unchecked["border"] = "1px solid var(--answer-background-opacity)";
    checked["border"] = "1px solid var(--answer-color)";
    if (isFill) {
      unchecked["backgroundColor"] = "var(--answer-background-opacity)";
      checked["backgroundColor"] = "var(--answer-background-opacity)";
    }
  } else {
    if (colorCode.length === 3) {
      unchecked["border"] = "1px solid #" + colorCode[1];
      checked["border"] = "1px solid #" + colorCode[2];
      if (isFill) {
        checked["backgroundColor"] = "#" + colorCode[2];
      }
    } else {
      unchecked["border"] = "1px solid #" + colorCode[1];
      unchecked["color"] = "#" + colorCode[3];
      checked["border"] = "1px solid #" + colorCode[2];
      checked["color"] = "#" + colorCode[4];
      if (isFill) {
        checked["backgroundColor"] = "#" + colorCode[2];
      }
    }
  }

  itemStyle.unchecked = {
    ...itemStyle,
    ...unchecked,
  };

  itemStyle.checked = {
    ...itemStyle,
    ...checked,
  };
  return itemStyle;
}
